import React from 'react';
import PropTypes from 'prop-types';

export class ModalWithChild extends React.PureComponent {
  static propTypes = {
    options: PropTypes.object,
  };

  static defaultProps = {
    options: {},
  };

  render() {
    const { options } = this.props;
    const { children = null } = options;

    return <div className="white-box">{children}</div>;
  }
}
